<template>
  <!-- 用户余额 -->
 <div >
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true" ref="" class="demo-form-inline" label-width="110px" size="mini">
        <div class="searchBox inpBox">
            <div class="item">
              <el-form-item label="客户名称:" prop="zxAccNm">
                <el-input  placeholder="" v-model="searchFrom.zxAccNm"></el-input>
              </el-form-item>
              <el-form-item label="客户类型:" prop="accountType">
                <el-select  v-model="searchFrom.accountType"   placeholder="请选择">
                  <el-option label="请选择" value=""></el-option>
                  <el-option label="货主" value="1"></el-option>
                  <el-option label="司机" value="2"></el-option>
                  <el-option label="车队" value="3"></el-option>
                  <el-option label="车队长" value="4"></el-option>
                </el-select>
              </el-form-item>
            </div>
        </div>
       <div class="searchBtnBox">
         <!-- v-if="btnFlg[0]" -->
           <el-form-item btnCode="00JP00IB001" >
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods' height="100%" style="width: 100%" center border>
        <el-table-column type="index" fixed prop="date" width="55" label="序号"></el-table-column>
         <el-table-column property="zxAccNm" width="400"  :formatter="emptyFn"   label="客户名称"></el-table-column>
       <el-table-column property="weight"   :formatter="emptyFn"   label="客户类型">
          <template scope="scope">{{[ "货主","司机", "车队","车队长"][scope.row.accountType-1]}}</template>
        </el-table-column>
         <el-table-column label="银行账号余额" >
            <template slot-scope="scope">
              <el-button type="text" size="mini" btnCode="00JP00IB002"   @click="chakanFN(scope.row)">查看</el-button>
            </template>
        </el-table-column>
        <el-table-column property="accountMoney"    :formatter="emptyFn"   label="平台账户余额"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 银行账号余额 -->
    <el-dialog  title="银行账号余额"  :visible.sync="dialogYE" width="400px"   :close-oni-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
      <div class="yueBox">{{zxAcoun}}</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogYE = false">关闭</el-button>
      </span>
   </el-dialog>
 </div>

</template>

<script>
import { getBtn } from '@/utils/getButton'
import { emptyFn, dateTimeFormat } from '@/utils/util'
import {
  searchSjAmt, // 余额
  tAccountCustinfoList // 列表
} from '@/api/consignment'
export default {
  data () {
    return {
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      h: '500px',
      // 查询调价
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      tableList: [],
      loading: 'false',
      total: 0,
      dialogYE: false,
      zxAcoun: 0,
      btnFlg: [],
      btnIdArr: ['00JP00IB001', '00JP00IB002']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/userWallet/userBalance')
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 92) + 'px'
  },
  methods: {
    // 查看
    chakanFN (row) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      searchSjAmt({ id: row.zxAcountId }).then(res => {
        loading.close()
        this.dialogYE = true
        this.zxAcoun = res
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcodes) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcodes.split(/[(\r\n)\r\n]+/) }

      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
      console.log(selection)
      this.weight = 0.00
      selection.forEach(item => {
        this.weight += item.weight
      })
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      tAccountCustinfoList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    billDetails (row) {
      this.$router.push({ name: 'billDetails', query: { billId: row.id } })
    },

    // 重置
    resetForm (formName) {
      // debugger
      // this.$refs[formName].resetFields()
      // this.searchFrom.createTime=null
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50
      }
    },
    closeDialog () {
      this.addForm = {}
      this.CHFrom = {}
    }
  }
}
</script>

<style scoped lang='less'>
.inpBox .el-date-editor{
      width: 350px!important;
}
.yueBox{
  text-align: center;
  font-size: 22px;
  color: #F56C6C;
}
</style>
